import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Text, Title } from "./studentDrawerKonularim";
import { db, auth } from "../../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { CustomLink, Button } from "../../../components/buttons/Button.styled";
import Loading from "../../../components/Loading"; // ✅ Loading import edildi

function DrawerOgretmenlerim() {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ loading state eklendi

  const fetchTeachers = async () => {
    const currentUser = auth.currentUser;
    const currentUserUid = currentUser ? currentUser.uid : null;

    if (currentUserUid) {
      try {
        const userDoc = await getDoc(doc(db, "users", currentUserUid));
        if (userDoc.exists()) {
          const teachers = userDoc.data().teachers || [];
          setTeachers(teachers);
        } else {
          console.error("Kullanıcı belgesi bulunamadı.");
        }
      } catch (error) {
        console.error("Öğrenci bilgilerini alma hatası:", error);
      } finally {
        setLoading(false); // ✅ İstek bitince loading kapat
      }
    } else {
      setLoading(false); // Kullanıcı yoksa loading kapat
    }
  };

  useEffect(() => {
    fetchTeachers();
  }, []);

  if (loading) {
    return <Loading />; // ✅ Spinner gösterilir
  }

  return (
    <Container>
      <Title>
        <Text>Öğretmenlerim</Text>
      </Title>
      <Main>
        <Table>
          <thead>
            <tr>
              <th>Öğretmen İsmi</th>
              <th>İletişim</th>
            </tr>
          </thead>
          <tbody>
            {teachers.length > 0 ? (
              teachers.map((teacher) => (
                <TeacherRow key={teacher.uid} teacherUid={teacher.uid} />
              ))
            ) : (
              <tr>
                <td colSpan="2">Öğretmen bulunamadı.</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Main>
    </Container>
  );
}

const TeacherRow = ({ teacherUid }) => {
  const [teacherData, setTeacherData] = useState(null);
  const [loadingRow, setLoadingRow] = useState(true); // ✅ Satır için loading eklendi

  useEffect(() => {
    const fetchTeacherData = async () => {
      try {
        const teacherDoc = await getDoc(doc(db, "users", teacherUid));
        if (teacherDoc.exists()) {
          setTeacherData(teacherDoc.data());
        } else {
          console.error(`Öğretmen belgesi bulunamadı: ${teacherUid}`);
        }
      } catch (error) {
        console.error(`Öğretmen bilgilerini alma hatası: ${error}`);
      } finally {
        setLoadingRow(false); // ✅ Satır yükleme bitti
      }
    };
    fetchTeacherData();
  }, [teacherUid]);

  return (
    <tr>
      <td>
        {loadingRow ? "Yükleniyor..." : teacherData?.userData.displayName || ""}
      </td>
      <td>
        {!loadingRow && (
          <CustomLink to={`/mesaj-gonder/${teacherUid}`}>
            <Button>Mesaj At</Button>
          </CustomLink>
        )}
      </td>
    </tr>
  );
};

/* --- STYLES --- */
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

const Main = styled.div`
  width: 100%;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    text-align: center;
    padding: 8px;
  }
  tr {
    border-bottom: 1px solid var(--main-color);
  }
`;

export default DrawerOgretmenlerim;
